import { LibraryContentType, LibraryItem } from './types';

export function libraryMediaAccept(type: LibraryContentType): string {
  if (type === 'audio') return 'audio/*';
  if (type === 'model_3d') return 'image/*,video/*';
  return type === 'movie' || type === 'shot_batch' ? 'video/*' : 'image/*';
}

export function libraryMediaFileAllowed(type: LibraryContentType, file: Pick<File, 'type'>): boolean {
  return libraryMediaAccept(type).split(',').some(pattern => file.type.startsWith(pattern.replace('*', '')));
}

export function libraryMediaHint(type: LibraryContentType): string {
  return type === 'audio' ? 'Audio file' : type === 'model_3d' ? '3D model preview — image or video' : type === 'movie' ? 'Video file' : type === 'game' ? 'Game preview image' : 'Image';
}

export function modelPreviewMetadata(type: LibraryContentType, file: Pick<File, 'type'> | null): Pick<LibraryItem, 'model3d'> {
  return type === 'model_3d' && file ? { model3d: { mediaType: file.type.startsWith('video/') ? 'video' : 'image' } } : {};
}

export function libraryTypeLabel(type: LibraryContentType): string {
  return type === 'model_3d' ? '3D model' : type === 'movie' ? 'video' : type.replace('_', ' ');
}
